import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as SVG } from "./SVG/welfare.svg";

const Icon = React.forwardRef((props, ref) => (
  <SvgIcon {...props} ref={ref} component={SVG} />
));
export default Icon;
